(ns ycweb.app.keepaside
  (:require
    [rum.core :as rum]
    [ycweb.app.common :as yac]
    [ycweb.app.pos.dev]
    [ycweb.app.website.keepaside.keepaside]

    [ycweb.components.state :as state]
    [ycweb.components.flow :as flow]
    [ycweb.components.grid :as grid]
    [ycweb.components.appcommon :as appcommon]

    ;; These are required for their multimethods, don't worry about them not being referenced.
    [ycweb.components.cards]
    [ycweb.components.transitions :as t]
    [ycweb.components.common :as cmn]
    [ycweb.util.comms :as comms])

  (:require-macros
    [ycweb.util.core :as yuc]))

(yac/init-sentry)

(enable-console-print!)

(println "Loading Keepaside.")
(println "Build Number:" (yuc/env :build-number "dev"))


(rum/defc loading < rum/static []
  [:div
   [:p "Loading..."]])

(defmethod flow/render-screen :loading [app-atom _]
  (loading))

;; Startup
(defmethod comms/receive :chsk/state [app-atom [old new]]
  (if (and (:open? new) (not (get-in @app-atom [:comms :started])))
    (do
      (comms/send :web/start {})
      (swap! app-atom assoc-in [:comms :started] true))))

(defmethod comms/receive :web/start [app-atom e]
  (swap! app-atom
    #(->
       %
       (assoc
         :opts (:opts e)
         :user (:user e)
         :stats (:stats e)
         :config (:config e)))))

(defn initial-state [started?]
  {:page {:screen :loading}
   :app {:started started? :version (yuc/env :build-number "dev") :app "web"}
   :device {:screen (state/screen-size) :id (comms/deviceid)}})

(defonce app-atom
  (atom (initial-state false)))

(defn ^:dev/after-load refresh []
  (rum/mount
    (appcommon/root app-atom)
    ;;todo?
    ;;header-react-mount
    (.getElementById js/document "keepaside-react-mount")))

(defmethod grid/action :state/reset [app-atom config _]
  (reset! app-atom
    (merge
      (initial-state true)
      config))
  (comms/send :web/start {})
  (refresh))

(defn main []
  ;;todo?
  ;;header-react-mount
  (let [pos (appcommon/entry-main "keepaside-react-mount" app-atom refresh)]
    (rum/hydrate (appcommon/root app-atom) pos)))


